namespace Matrix.Indexation {
    export interface CompositeConstituentForm {
        IndexationProfileCode: Serenity.StringEditor;
        CompositeIndexCode: Serenity.StringEditor;
        ConstituentIndexCode: Serenity.StringEditor;
        Weight: Serenity.DecimalEditor;
        HedgeRatio: Serenity.DecimalEditor;
        DefaultSortOrder: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class CompositeConstituentForm extends Serenity.PrefixedContext {
        static formKey = 'Indexation.CompositeConstituent';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CompositeConstituentForm.init)  {
                CompositeConstituentForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.IntegerEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(CompositeConstituentForm, [
                    'IndexationProfileCode', w0,
                    'CompositeIndexCode', w0,
                    'ConstituentIndexCode', w0,
                    'Weight', w1,
                    'HedgeRatio', w1,
                    'DefaultSortOrder', w2,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
